import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getUser() {
    return this.http.get("https://street-jams-001.herokuapp.com/api/users");
    // return this.http.get("/api/users");
  }
}
